<template>
  <div>
    <table>
      <tr>
        <td>E-Mail-Adressen</td>
        <td>
          <SogDataLabel :value="details?.getValue(PersonDetailsId.RegistrationOfficeEmails)" />
        </td>
      </tr>
      <tr>
        <td>Kennzeichen-Präfixe</td>
        <td>
          <SogDataLabel :value="details?.getValue(PersonDetailsId.RegistrationOfficePrefixes)" />
        </td>
      </tr>
      <tr>
        <td>Kreisschlüssel</td>
        <td>
          <SogDataLabel :value="details?.getValue(PersonDetailsId.RegistrationOfficeDistrictKeys)" />
        </td>
      </tr>
    </table>
  </div>
</template>

<script setup lang="ts">
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import PersonDetails from "@/shared/model/personDetails";
import PersonDetailsId from "@/shared/model/personDetailsId";

interface Props {
  details?: PersonDetails
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
      details: undefined
    }
)
</script>

<style scoped>
td {
  padding-right: 10px;
}
</style>
